<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <div style="position: absolute;top:10px;right:20px;z-index: 99">
        <div>
          <el-checkbox v-model="checked" style="padding-left:16px;">每60秒刷新当前页面</el-checkbox>
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item,index) in commontabs"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <finance-seach
        ref="financeSeachRefs"
        :column-option="columnList"
        :select-array="['type','invoiceType','state','orgName']"
        @onSearch="onSearch"
      >
        <div class="search_rightitem" v-show="activeName === '1'">
          <el-button type="primary" :disabled="!list.length" @click="onBatch(1)">批量通过</el-button>
          <el-button type plain :disabled="!list.length" @click="onBatch(2)">批量拒绝</el-button>
        </div>
        <div class="search_rightitem" v-show="activeName === '2'">
          <el-button
            type="primary"
            :disabled="!list.some(ele=>ele.extract===1)"
            @click="onBatch(5)"
          >批量认领</el-button>
        </div>
      </finance-seach>
      <div class="box-table" :style="{height: $store.state.Sell.height+'px'}">
        <el-table
          type="reset"
          border
          ref="tableRef"
          :data="list"
          :max-height="$store.state.Sell.height"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed
            type="selection"
            :selectable="selectableFun"
            width="35"
            v-if="activeName==='1'||activeName==='2'"
          ></el-table-column>
          <el-table-column
            label="退票编号"
            width="135"
            prop="subNumber"
            show-overflow-tooltip
            :key="'1'"
          ></el-table-column>
          <el-table-column
            prop="cusName"
            label="公司名称"
            min-width="110"
            show-overflow-tooltip
            :key="'2'"
          ></el-table-column>
          <el-table-column
            v-if="activeName==='4'&&invoice===1"
            prop="invoiceNumber"
            show-overflow-tooltip
            label="原发票编号"
            min-width="110"
            :key="'3'"
          ></el-table-column>
          <el-table-column
            v-if="activeName==='4'&&invoice===1"
            label="原发票金额"
            min-width="100"
            :key="'4'"
          >
            <template slot-scope="scope">{{scope.row.amount|priceFilter}}</template>
          </el-table-column>
          <el-table-column
            v-if="activeName==='4'&&invoice===1"
            label="红字信息表编号"
            prop="invoiceRedCode"
            show-overflow-tooltip
            min-width="120"
            :key="'5'"
          ></el-table-column>
          <el-table-column
            v-if="activeName==='4'&&invoice===1"
            label="红字发票编号"
            show-overflow-tooltip
            prop="invoiceRedNumber"
            min-width="110"
            :key="'6'"
          ></el-table-column>
          <el-table-column
            prop="invoiceCode"
            label="发票编号"
            min-width="110"
            :key="'8'"
            v-else
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            v-if="activeName==='4'&&invoice===1"
            label="红字发票金额"
            min-width="110"
            :key="'7'"
          >
            <template slot-scope="scope">{{scope.row.redAmonut|priceFilter}}</template>
          </el-table-column>
          <el-table-column label="发票金额" min-width="100" :key="'9'" v-else>
            <template slot-scope="scope">{{scope.row.redAmonut}}</template>
          </el-table-column>
          <el-table-column prop="taxAmount" label="税额" :key="'10'">
            <template slot-scope="scope">{{scope.row.taxAmount|priceFilter}}</template>
          </el-table-column>
          <el-table-column prop="invoiceType" label="发票类型" :key="'11'"></el-table-column>
          <el-table-column prop="type" label="退票类型" :key="'12'"></el-table-column>
          <el-table-column prop="createUser" label="申请人" :key="'13'"></el-table-column>
          <el-table-column prop="orgName" label="所属部门" :key="'14'"></el-table-column>
          <el-table-column label="申请时间" :key="'15'" width="125">
            <template slot-scope="scope">{{scope.row.createDate|dateFilterL}}</template>
          </el-table-column>
          <el-table-column prop="processUser" label="认领人" :key="'16'" v-if="activeName==='2'"></el-table-column>
          <el-table-column
            label="认领时间"
            :key="'17'"
            v-if="activeName==='2'||activeName==='3'"
            width="125"
          >
            <template slot-scope="scope">{{scope.row.processDate|dateFilterL}}</template>
          </el-table-column>
          <el-table-column label="退票状态" :key="'18'" v-if="activeName==='4'" width="84px">
            <template
              slot-scope="scope"
            >{{scope.row.state===1?'审核中':scope.row.state===2?'已通过':scope.row.state===3?'审核不通过 ':scope.row.state===4?'已退票':scope.row.state===5?'拒绝退票':'--'}}</template>
          </el-table-column>
          <el-table-column label="处理时间" :key="'19'" v-if="activeName==='4'" width="125">
            <template slot-scope="scope">{{scope.row.processDate|dateFilterL}}</template>
          </el-table-column>
          <el-table-column prop="processUser" label="处理人" :key="'20'" v-if="activeName==='4'"></el-table-column>
          <el-table-column label="操作" :key="'21'" fixed="right" width="110">
            <template slot-scope="scope">
              <el-button @click="audit(scope.row)" v-if="activeName==='1'" type="text">审核</el-button>
              <el-button @click="onDetails(scope.row)" v-if="activeName==='4'" type="text">查看</el-button>
              <div v-if="activeName==='2'||activeName==='3'">
                <el-button type="text" v-if="scope.row.extract===1" @click="onClaim(scope.row,4)">认领</el-button>
                <el-button type="text" v-if="scope.row.extract===3" @click="onClaim(scope.row,3)">提取</el-button>
                <el-button
                  type="text"
                  v-if="invoice===1&&activeName==='3'"
                  @click="onExport(scope.row)"
                >导出明细</el-button>
                <el-button type="text" v-if="scope.row.extract===2" @click="onprocess(scope.row)">处理</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <!------------------------  审核 不通过 弹框   --------------------->
    <el-dialog title="审核确认" :visible.sync="dialogVisible" width="517px">
      <div style="padding:0 30px">
        <div style="font-weight: 400;color: #D35E5E;margin-bottom:20px;">确定拒绝退票申请？</div>
        <el-input v-model.trim="mark" type="textarea" :rows="4" placeholder="请填写被拒原因！"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onUpdataState(85)">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <open-or-close
      @onUpdataState="onUpdataState"
      :content="content"
      :title="title"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import pagination from '@/components/pagination'
import { downLoadFileBlob } from '@/util/tool'
import { commontabs } from './util/data'
import {
  commonList1,
  commonList2,
  commonList3,
  commonList4,
  commonListRed4
} from './util/dataBot'
import {
  financeCreditCoeDerive,
  querySubInvoiceByFinance,
  updateStateByFprsIdwrit
} from '@/api/fiance/fianceManage'
import financeSeach from '@/components/module/financeSeach'
export default {
  components: {
    'open-or-close': OpenOrClose,
    pagination,
    financeSeach
  },
  data () {
    return {
      title: '',
      content: '',
      activeName: '1', // tabs选中状态
      invoice: 1, // 1 红字 2 退票
      columnList: commonList1,
      commontabs, // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      checkedList: [],
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      typeNum: 0, // 1 批量通过 2 批量不通过 3 提取 4 认领 5 批量认领
      ptList: [
        'updateStateByOcisIdReviewAllTruePt',
        'updateStateByOcisIdReviewAllFalsePt',
        'updateStateByOcisIdExtractPt',
        'updateStateByOcisIdClaimPt',
        'updateStateByOcisIdClaimAllPt'
      ],
      hzList: [
        'updateStateByOcisIdReviewAllTrueHz',
        'updateStateByOcisIdReviewAllFalseHz',
        'updateStateByOcisIdExtractHz',
        'updateStateByOcisIdClaimHz',
        'updateStateByOcisIdClaimAllHz'
      ],
      mark: '', // 拒绝退票备注
      dialogVisible: false, // 拒绝退票弹框
      checked: false,
      columnArr: []
    }
  },
  watch: {
    checked (newVal) {
      clearInterval(this.timer)
      if (newVal) {
        this.timer = setInterval(() => {
          this.getList()
        }, 60000)
      }
      return newVal
    },
    '$route.name' (newVal) {
      this.activeName = '1'
      if (newVal === 'redReturnTicketApplyList') {
        this.invoice = 1
      } else {
        this.invoice = 2
      }
      this.$refs.financeSeachRefs.searchReset()
    }
  },
  mounted () {
    if (this.$route.name === 'redReturnTicketApplyList') {
      this.invoice = 1
    } else {
      this.invoice = 2
    }
    this.activeName = this.$route.query.actName || '1'
    this.getList()
  },
  methods: {
    onExport (row) {
      financeCreditCoeDerive({
        financeCreditUrl: this.$store.state.financeCreditUrl,
        oisId: row.id,
        type:
          row.type === '开票退票'
            ? 'orderContractInvoiceSub'
            : 'purchaseContractInvoiceSub'
      }).then((res) => {
        downLoadFileBlob(this, res)
      })
    },
    selectableFun (row) {
      if (this.activeName === '1') {
        return true
      }
      if (this.activeName === '2') {
        return row.extract === 1
      }
    },
    onSearch (arr) {
      // 搜索
      this.pageSize = 30
      this.currentPage = 1
      this.columnArr = arr
      this.getList()
    },
    onUpdataState (num) {
      if (num && !this.mark) {
        this.$message.error('请填写拒绝退票原因！')
        return
      }
      // 弹框确认
      const { hzList, ptList, typeNum } = this
      const obj = {}
      if (typeNum === 1) {
        obj.state = 2
      } else if (typeNum === 2) {
        obj.state = 3
      } else if (typeNum === 3) {
        obj.processState = 1
      } else {
        obj.processState = 2
      }
      this.checkedList.forEach((ele) => {
        ele.type =
          ele.type === '开票退票'
            ? 'orderContractInvoiceSub'
            : 'purchaseContractInvoiceSub'
      })
      const str = this.invoice === 1 ? hzList[typeNum - 1] : ptList[typeNum - 1]
      updateStateByFprsIdwrit(this.checkedList, obj, str).then((res) => {
        if (res.data.code === 200) {
          if (typeNum === 3) {
            this.activeName = '4'
          } else {
            this.activeName = '2'
          }
          this.dialogVisible = false
          this.mark = ''
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onBatch (type) {
      // 批量处理
      if (this.checkedList.length > 0) {
        this.typeNum = type
        if (type === 2) {
          this.dialogVisible = true
        } else {
          if (type === 1) {
            const num = this.checkedList.reduce((total, cur) => {
              return total + cur.amount
            }, 0)
            this.title = '审核确认'
            this.content = `本次审核退票申请：${
              this.checkedList.length
            }条；退票总金额：<span style="color:#D35E5E">${parseFloat(
              num
            ).toFixed(2)}</span><br/>确定审核通过退票申请？`
          // } else if (type === 3) {
          //   this.title = '提取确定'
          //   this.content = `该申请已由【${name}】认领，确定提取退票申请？`
          } else {
            this.title = '认领确定'
            this.content = '确定认领退票申请？'
          }
          this.$refs.openOrCloseRefs.onInitial()
        }
      } else {
        this.$message.error('请选择一条或多条！')
      }
    },
    onClaim (row, num) {
      // 认领 提取
      this.typeNum = num
      this.checkedList = [row]
      this.onUpdataState()
    },
    handleSelectionChange (val) {
      // 多选
      this.checkedList = val
    },
    onDetails (row) {
      // 查看
      this.$router.push({
        name: 'commonReturnbank',
        query: {
          id: row.id,
          type: row.type,
          state: 3,
          invoice: this.invoice
        }
      })
    },
    onprocess (row) {
      // 处理
      this.$router.push({
        name: 'commonReturnbank',
        query: {
          id: row.id,
          type: row.type,
          state: 2,
          invoice: this.invoice
        }
      })
    },
    audit (row) {
      // 审核
      this.$router.push({
        name: 'commonReturnbank',
        query: {
          id: row.id,
          type: row.type,
          state: 1,
          invoice: this.invoice
        }
      })
    },
    // tabs切换时触发的事件
    handleClick (tab) {
      this.currentPage = 1
      if (tab.name === '1') {
        this.columnList = commonList1
      } else if (tab.name === '2') {
        this.columnList = commonList2
      } else if (tab.name === '3') {
        this.columnList = commonList3
      } else if (tab.name === '4') {
        this.columnList = this.invoice === 1 ? commonListRed4 : commonList4
      }
      this.activeName = tab.name
      this.$refs.financeSeachRefs.searchReset()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.columnArr,
        queryPageName: ''
      }
      querySubInvoiceByFinance(
        this.invoice,
        this.activeName,
        this.currentPage,
        this.pageSize,
        params
      ).then((res) => {
        if (res.data.code === 200) {
          this.loadingTable = false
          this.list = res.data.obj.records
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
